import { createAppointmentTypesService } from '@shared/api/appointment-types.service'
import { authorizedHttpClient } from './http-client'

export const AppointmentTypesService = createAppointmentTypesService(authorizedHttpClient, import.meta.env.VITE_API_URL)
